// import React from "react";
// import PropTypes from "prop-types";
// import { styled } from "@mui/material/styles";
// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";
// import * as ActionTypes from '../actions/types';
// import { connect } from 'react-redux';
// // import createHistory from 'history/createBrowserHistory';

// const styles = {
//   root: {
//     padding: "2px 4px",
//     display: "flex",
//     alignItems: "center",
//     width: '100%'
//   },
//   input: {
//     marginLeft: 8,
//     flex: 1
//   },
//   iconButton: {
//     padding: 10
//   },
//   divider: {
//     width: 1,
//     height: 28,
//     margin: 4
//   }
// };

// class CustomizedInputBase extends React.Component {
//   state = {
//     l: ''
//   }

//   componentWillMount(){
//     this.props.resetSearch(false)
//   }

//   componentWillUnmount(){
//     this.props.resetSearch(false)

//   }

//   render() {
//     const { classes } = this.props;

//     return (
//       <Paper className={classes.root} elevation={1}>
//         <IconButton className={classes.iconButton} aria-label="Menu">
//           <SearchIcon />
//         </IconButton>
//         <InputBase className={classes.input} placeholder="Search" autoFocus
//           onChange={(e) => this.props.onChange(e.target.value)}
//         />
//         <IconButton className={classes.iconButton} aria-label="Search"
//           onClick={(e) => {
//             // console.log('sdffds')
//             this.props.searchBarActivate(false)
//             this.props.resetSearch(false)
//           }}>
//           <CloseIcon />
//         </IconButton>
//       </Paper>
//     );
//   }
// }

// CustomizedInputBase.propTypes = {
//   classes: PropTypes.object.isRequired
// };

// const mapStateToProps = state => {
//   return {
//     redux: state,
//   };
// };



// const mapDispatchToProps = dispatch => {
//   return {
//     searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
//     searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
//   };
// };


// export default connect(mapStateToProps, mapDispatchToProps)(styled(styles)(CustomizedInputBase));


import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { connect } from "react-redux";
import * as ActionTypes from "../actions/types";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: "100%",
}));

const StyledInputBase = styled(InputBase)({
  marginLeft: 8,
  flex: 1,
});

const StyledIconButton = styled(IconButton)({
  padding: 10,
});

class CustomizedInputBase extends React.Component {
  state = {
    l: "",
  };

  componentDidMount() {
    this.props.resetSearch(false);
  }

  componentWillUnmount() {
    this.props.resetSearch(false);
  }

  render() {
    return (
      <StyledPaper elevation={1}>
        <StyledIconButton aria-label="Menu">
          <SearchIcon />
        </StyledIconButton>
        {/* <StyledInputBase
          placeholder="Search"
          autoFocus
          onChange={(e) => this.props.onChange(e.target.value)}
        /> */}
        <StyledInputBase
  placeholder="Search"
  autoFocus
  value={this.props.value || ""}
  onChange={(e) => this.props.onChange(e.target.value)}
/>
        <StyledIconButton
          aria-label="Search"
          onClick={() => {
            this.props.searchBarActivate(false);
            this.props.resetSearch(false);
          }}
        >
          <CloseIcon />
        </StyledIconButton>
      </StyledPaper>
    );
  }
}

CustomizedInputBase.propTypes = {
  searchBarActivate: PropTypes.func.isRequired,
  resetSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  redux: state,
});

const mapDispatchToProps = (dispatch) => ({
  searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data }),
  searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomizedInputBase);

